var _defs, _g, _g2, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLpMultipleAppsEstimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eXft3SuVDe61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 340",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "254c9d68f3cc4d12b4f1169591fb5504",
    "export-id": "802a90eb3d2b4f7b90d1021891de4b13",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eXft3SuVDe626-fill",
    x1: 29.5,
    y1: 0,
    x2: 29.5,
    y2: 59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eXft3SuVDe626-fill-0",
    offset: "0%",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eXft3SuVDe626-fill-1",
    offset: "100%",
    stopColor: "#005d7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eXft3SuVDe633-fill",
    x1: 29.5,
    y1: 0,
    x2: 29.5,
    y2: 59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eXft3SuVDe633-fill-0",
    offset: "0%",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eXft3SuVDe633-fill-1",
    offset: "100%",
    stopColor: "#005d7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eXft3SuVDe637-fill",
    x1: 29.5,
    y1: 0,
    x2: 29.5,
    y2: 59,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eXft3SuVDe637-fill-0",
    offset: "0%",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eXft3SuVDe637-fill-1",
    offset: "100%",
    stopColor: "#005d7f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe62",
    transform: "matrix(.500213 0 0 0.500213 64.463379 69.400896)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.42578,73.5c0-19.5435,0-29.3152,2.57214-37.2234C10.1964,20.2936,22.74,7.76272,38.7391,2.56953C46.6554,0,56.437,0,76.0003,0L266,0c19.564,0,29.345,0,37.261,2.56953c16,5.19319,28.543,17.72407,33.742,33.70707c2.572,7.9082,2.572,17.6799,2.572,37.2234v546c0,19.543,0,29.315-2.572,37.223-5.199,15.983-17.742,28.514-33.742,33.707C295.345,693,285.564,693,266,693h-189.9997c-19.5633,0-29.3449,0-37.2612-2.57-15.9991-5.193-28.5427-17.724-33.74118-33.707-2.57214-7.908-2.57214-17.68-2.57214-37.223v-546Z",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.324,1.61531h-190.6471c-19.3252,0-28.796.00996-36.438,2.49047C23.732,9.13918,11.5744,21.2845,6.53588,36.7757C4.05286,44.4099,4.04289,53.8712,4.04289,73.1768v546.6462c0,19.306.00997,28.767,2.49299,36.401c5.03852,15.491,17.19612,27.637,32.70302,32.67c7.642,2.481,17.1128,2.491,36.438,2.491h190.6471c19.325,0,28.796-.01,36.438-2.491c15.507-5.033,27.664-17.179,32.703-32.67c2.483-7.634,2.493-17.095,2.493-36.401v-546.6462c0-19.3056-.01-28.7669-2.493-36.4011-5.039-15.4912-17.196-27.63652-32.703-32.66992-7.642-2.48051-17.113-2.49047-36.438-2.49047ZM5.76694,36.5261C3.23438,44.3127,3.23438,53.934,3.23438,73.1768v546.6462c0,19.243,0,28.864,2.53256,36.651C10.8854,672.211,23.236,684.549,38.9891,689.662c7.7944,2.53,17.4255,2.53,36.6878,2.53h190.6471c19.262,0,28.893,0,36.688-2.53c15.753-5.113,28.103-17.451,33.222-33.188c2.532-7.787,2.532-17.408,2.532-36.651v-546.6462c0-19.2427,0-28.8641-2.532-36.6507-5.119-15.7371-17.469-28.07519-33.222-33.18848-7.795-2.530003-17.426-2.530003-36.688-2.530003h-190.6471c-19.2623,0-28.8934,0-36.6878,2.530003C23.236,8.45091,10.8854,20.789,5.76694,36.5261Z",
    clipRule: "evenodd",
    fill: "#262626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46875,71.8842c0-18.0401,0-27.0601,2.37428-34.36C13.6416,22.7707,25.2203,11.2037,39.9888,6.40996c7.3073-2.37187,16.3365-2.37187,34.3948-2.37187h193.2344c18.058,0,27.087,0,34.395,2.37187C316.781,11.2037,328.36,22.7707,333.158,37.5242c2.375,7.2999,2.375,16.3199,2.375,34.36v549.2308c0,18.04,0,27.06-2.375,34.36-4.798,14.754-16.377,26.32-31.145,31.114-7.308,2.372-16.337,2.372-34.395,2.372h-193.2343c-18.0584,0-27.0876,0-34.3949-2.372-14.7685-4.794-26.3472-16.36-31.14577-31.114-2.37428-7.3-2.37428-16.32-2.37428-34.36v-549.2308Z",
    fill: "#121515"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eXft3SuVDe67",
    r: 25.5,
    transform: "matrix(0-1 1 0 169.742959 624.10242)",
    fill: "#c0f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.191,25.8459c0-1.3382,1.085-2.423,2.423-2.423h34.771c1.339,0,2.423,1.0848,2.423,2.423s-1.084,2.4231-2.423,2.4231h-34.771c-1.338,0-2.423-1.0848-2.423-2.4231Z",
    clipRule: "evenodd",
    fill: "#262c2d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.001223 0)",
    mask: "url(#eXft3SuVDe612)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "eXft3SuVDe611",
    width: 306.426,
    height: 662.308,
    rx: 0,
    ry: 0,
    transform: "translate(17.7891 15.3457)",
    fill: "#fdf4e7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eXft3SuVDe612",
    "mask-type": "alpha",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1298,23.4227v-3.6347c0-2.4534-1.991-4.4423-4.4469-4.4423h-10.4138c-16.2801,0-24.4201,0-30.9121,2.4506-10.204,3.8519-18.259,11.8988-22.1148,22.0925-2.4531,6.4854-2.4531,14.6172-2.4531,30.8807v551.4605c0,16.263,0,24.395,2.4531,30.88c3.8558,10.194,11.9108,18.241,22.1148,22.093c6.492,2.45,14.632,2.45,30.912,2.45h195.466c16.28,0,24.42,0,30.912-2.45c10.204-3.852,18.259-11.899,22.114-22.093c2.454-6.485,2.454-14.617,2.454-30.88v-551.4604c0-16.2636,0-24.3954-2.454-30.8808-3.855-10.1937-11.91-18.2406-22.114-22.0925-6.492-2.4506-14.632-2.4506-30.912-2.4506h-10.414c-2.456,0-4.447,1.9889-4.447,4.4423v3.6347l-.058-.0019.058.4057c0,9.5906-7.782,17.3654-17.383,17.3654h-130.979c-9.5999,0-17.3825-7.7748-17.3825-17.3654l.058-.4057-.0577.0019Z",
    fill: "#c4c4c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe614"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(36 77)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(106 77)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(176 77)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(246 77)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(36 152)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(106 152)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(176 152)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(246 152)",
    fill: "#efe0cb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(36 227)",
    fill: "#efe0cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe625",
    transform: "matrix(.982708 0 0 0.982708 3.553506 3.925314)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(176 227)",
    fill: "url(#eXft3SuVDe626-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.177,237.738c-2.607,0-4.72,2.114-4.72,4.72v27.494c0,2.607,2.113,4.72,4.72,4.72h18.651c2.606,0,4.72-2.113,4.72-4.72v-27.494c0-2.607-2.114-4.72-4.72-4.72h-18.651Zm1.782,3.121c-1.867,0-3.381,1.514-3.381,3.382c0,1.867,1.514,3.381,3.381,3.381h15.086c1.867,0,3.381-1.514,3.381-3.381c0-1.868-1.514-3.382-3.381-3.382h-15.086Zm12.225,19.768c0-1.724,1.397-3.121,3.121-3.121s3.121,1.397,3.121,3.121v7.803c0,1.724-1.397,3.121-3.121,3.121s-3.121-1.397-3.121-3.121v-7.803Zm-12.485-10.924c-1.724,0-3.121,1.397-3.121,3.121s1.397,3.121,3.121,3.121s3.121-1.397,3.121-3.121-1.397-3.121-3.121-3.121Zm4.682,3.121c0-1.724,1.398-3.121,3.121-3.121c1.724,0,3.122,1.397,3.122,3.121s-1.398,3.121-3.122,3.121c-1.723,0-3.121-1.397-3.121-3.121Zm10.924-3.121c-1.724,0-3.121,1.397-3.121,3.121s1.397,3.121,3.121,3.121s3.121-1.397,3.121-3.121-1.397-3.121-3.121-3.121Zm-18.727,10.924c0-1.724,1.397-3.121,3.121-3.121s3.121,1.397,3.121,3.121-1.397,3.121-3.121,3.121-3.121-1.397-3.121-3.121Zm10.924-3.121c-1.723,0-3.121,1.397-3.121,3.121s1.398,3.121,3.121,3.121c1.724,0,3.122-1.397,3.122-3.121s-1.398-3.121-3.122-3.121ZM194.578,268.43c0-1.724,1.397-3.121,3.121-3.121s3.121,1.397,3.121,3.121-1.397,3.121-3.121,3.121-3.121-1.397-3.121-3.121Zm10.924-3.121c-1.723,0-3.121,1.397-3.121,3.121s1.398,3.121,3.121,3.121c1.724,0,3.122-1.397,3.122-3.121s-1.398-3.121-3.122-3.121Z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.782,244.048l-.259.237h-1.442l-.259-.237.259-.237h1.442l.259.237Zm-2.149,2.186l.518-.474h1.302l.525.474h-2.345Zm1.82-3.891h-1.302l-.518-.475h2.345l-.525.475Zm-1.435,3.297l-.518.474v-1.886l.133-.12.385.355v1.177Zm0-2l-.385.354-.133-.12v-1.885l.518.468v1.183Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.244,242.343l.4-.354-.136-.121h-1.86l-.128.121.399.354h1.325Zm-.937,1.303l.343.355.116-.121v-1.379h-.459v1.145Zm.343.469l.116.113v1.886l-.116.12-.343-.354v-1.411l.343-.354Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.913,246l-.39-.355v-1.179l.39-.354.132.114v1.654l-.132.12Zm-.453-1.711h-1.433l-.258-.241.258-.234h1.433l.258.234-.258.241Zm.063-1.945h-1.427l-.389-.36.132-.116h2.206l-.522.476Zm.132,3.89h-2.206l.515-.475.139-.006h1.288l.39.359-.126.122Zm-2.074-2.243l-.132-.12v-1.654l.132-.114.383.355v1.178l-.383.355Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.982709 0 0 0.982709 4.253586 3.925057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(246 227)",
    fill: "url(#eXft3SuVDe633-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.497,273.593c-9.413,0-17.071-7.663-17.071-17.082c0-9.418,7.658-17.081,17.071-17.081s17.072,7.663,17.072,17.081c0,9.419-7.659,17.082-17.072,17.082Zm0-35.973c-10.41,0-18.88,8.475-18.88,18.891c0,10.417,8.47,18.891,18.88,18.891c10.411,0,18.88-8.474,18.88-18.891c0-10.416-8.469-18.891-18.88-18.891Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.689,249.504l-4.852,6.353c.161.933-.137,1.894-.815,2.573-.571.572-1.321.857-2.071.857s-1.5-.285-2.07-.857c-1.142-1.142-1.142-3.001,0-4.143.654-.656,1.587-.958,2.496-.825l6.428-4.848c.253-.191.607-.165.83.059.223.225.246.579.054.831Zm-7.193-7.013c-7.784,0-14.117,6.337-14.117,14.126c0,7.788,6.333,14.125,14.117,14.125c7.785,0,14.118-6.337,14.118-14.125c0-7.789-6.333-14.126-14.118-14.126Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.982709 0 0 0.982709 2.34293 4.692057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    ry: 10,
    transform: "translate(106 226.738565)",
    fill: "url(#eXft3SuVDe637-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.249,272.937l2.195,2.971c.38.515.997.515,1.378,0l2.195-2.971c.38-.515.997-.515,1.378,0l2.195,2.971c.38.515.997.515,1.378,0l2.195-2.971c.381-.515.998-.515,1.378,0l2.195,2.971c.381.515.998.515,1.378,0l2.195-2.971c.381-.515.998-.515,1.378,0l2.064,2.794c.297.401.804.117.804-.45v-4.501-31.736c0-1.129-.676-2.044-1.51-2.044h-25.537c-.833,0-1.509.915-1.509,2.044v31.736v4.507c0,.567.507.852.803.45l2.069-2.8c.38-.515.997-.515,1.378,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.176,256.028h17.006c.876,0,1.586-.475,1.586-1.062c0-.586-.71-1.062-1.586-1.062h-17.006c-.876,0-1.586.476-1.586,1.062c0,.587.71,1.062,1.586,1.062Z",
    transform: "translate(.598 0)",
    fill: "#006e97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.929,246.116h17.5c.739,0,1.339-.475,1.339-1.062c0-.586-.6-1.062-1.339-1.062h-17.5c-.74,0-1.339.476-1.339,1.062c0,.587.599,1.062,1.339,1.062Z",
    transform: "translate(.598 0)",
    fill: "#006e97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.721,260.984h17.915c.625,0,1.132-.475,1.132-1.062c0-.586-.507-1.062-1.132-1.062h-17.915c-.625,0-1.131.476-1.131,1.062c0,.587.506,1.062,1.131,1.062Z",
    transform: "translate(.598 0)",
    fill: "#006e97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.929,251.072h17.5c.739,0,1.339-.475,1.339-1.062c0-.586-.6-1.062-1.339-1.062h-17.5c-.74,0-1.339.476-1.339,1.062c0,.587.599,1.062,1.339,1.062Z",
    transform: "translate(.598 0)",
    fill: "#006e97"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe643",
    transform: "translate(7.731188-25.168808)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe644",
    transform: "translate(0 15.074243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.45 0 0 0.45 84.036527 90.720227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe646",
    transform: "translate(-93.954488 76.177157)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7085,193.571h3.6483v-18.17h-3.6483v18.17Z",
    fill: "#955835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3568,193.571h-1.2464v-11.796c.4204-.004.8368-.012,1.2464-.027v11.823Z",
    fill: "#7a482d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1492,171.254c0,9.278-6.0967,10.523-13.6161,10.523s-13.6161-1.245-13.6161-10.523c0-9.279,6.0967-55.384,13.6161-55.384s13.6161,46.105,13.6161,55.384Z",
    fill: "#467e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5326,181.777c-.0488,0-.0963,0-.1451-.001-.0054,0-.0108,0-.0163,0-.0067,0-.0135,0-.0203,0-.0122,0-.0258,0-.038,0-.0136,0-.0285,0-.0421,0-.0027,0-.0067,0-.0094,0-.0109,0-.0204,0-.0312,0-.0068,0-.0136,0-.0204,0-.0054,0-.0095,0-.0149,0-.0081,0-.0176,0-.0258,0-.0054,0-.0095,0-.0135,0-.0095,0-.019,0-.0285,0h-.0014c-.0488-.001-.0963-.001-.1437-.001-.0014,0-.0027,0-.0027,0-.0123,0-.0231,0-.034,0-.0013,0-.0027,0-.0027,0-6.0546-.059-11.0838-1.06-12.5744-6.658c2.4454,1.372,5.7643,1.669,9.4223,1.669c7.5195,0,13.6162-1.244,13.6162-10.523c0-7.373-3.8506-38.003-9.2054-50.27c4.2046,1.515,7.9087,16.998,10.266,31.427v31.596c-2.1389,1.999-5.386,2.603-9.1104,2.731-.4096.015-.826.024-1.2465.028-.1926.001-.3838.002-.5778.002Z",
    fill: "#3c672a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.168,193.816h3.3463v-19.602h-3.3463v19.602Z",
    fill: "#cc7844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4843,193.816h-1.0688v-12.417c.354-.039.7107-.113,1.0688-.221v12.638Z",
    fill: "#a7633a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8416,107.752c-6.7558,0-16.2352,16.493-16.2352,36.839s8.7171,36.839,16.2352,36.839s16.2338-16.493,16.2338-36.839-9.4793-36.839-16.2338-36.839Z",
    fill: "#5fae32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7676,131.554c-.6564-3.227-1.5299-6.235-2.5499-8.957c1.02,2.72,1.8935,5.73,2.5499,8.956v.001Z",
    fill: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0757,144.591c0-4.59-.4829-8.984-1.3075-13.037v-.001c.826,4.053,1.3075,8.448,1.3075,13.038Z",
    fill: "#3c672a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8126,181.43c-.0027,0-.0055,0-.0068,0c.0027,0,.0041,0,.0068,0Zm-.1809-.004c-.0014,0-.0014,0-.0028,0h.0028Z",
    fill: "#a7633a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8413,181.43c-.0109,0-.0217,0-.0312,0-.0027,0-.0041,0-.0068,0-.0109,0-.0204,0-.0312,0-.0014,0-.0027,0-.0041,0-.0108,0-.0203,0-.0298-.001-.0014,0-.0027,0-.0041,0-.0108,0-.0217,0-.0312,0-.0027,0-.004,0-.0054,0-.0231-.002-.0448-.002-.0665-.003h-.0027c-2.9459-.121-6.06-2.748-8.7523-7.115.8002.345,1.5977.535,2.383.535c7.5181,0,16.2352-16.493,16.2352-36.839c0-12.263-3.4464-23.121-7.6605-29.816c3.5183,1.485,7.415,6.661,10.2416,14.03.0108.026.019.05.0298.076c0,.003.0014.007.0027.009.0095.023.0177.045.0258.068.0027.007.0054.014.0081.021.0068.016.0136.034.019.051.0041.01.0082.019.0122.03.0055.015.0109.028.0163.043.0068.018.0136.036.0204.053.0027.008.0054.017.0081.025c1.0199,2.721,1.8934,5.729,2.5499,8.957.8246,4.053,1.3075,8.447,1.3075,13.037c0,11.914-2.9894,22.507-6.9756,29.241-2.3207,3.921-4.9804,6.533-7.5859,7.336-.0095.003-.0203.007-.0298.01-.3581.108-.7148.181-1.0688.221-.1926.02-.3839.031-.5737.031Z",
    fill: "#4e8f32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.852,188.207c0,5.989-4.855,10.844-10.841,10.844-5.987,0-10.842-4.855-10.842-10.844c0-5.99,4.855-10.844,10.842-10.844c5.986,0,10.841,4.854,10.841,10.844Z",
    fill: "#467e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.668,172.582c0,5.99-4.853,10.845-10.841,10.845-5.987,0-10.84-4.855-10.84-10.845c0-5.988,4.853-10.843,10.84-10.843c5.988,0,10.841,4.855,10.841,10.843Z",
    fill: "#467e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.16,156.825c0,5.989-4.854,10.844-10.841,10.844s-10.84-4.855-10.84-10.844s4.853-10.845,10.84-10.845s10.841,4.856,10.841,10.845Z",
    fill: "#467e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.835,155.358c0,5.99-4.853,10.845-10.84,10.845-5.988,0-10.841-4.855-10.841-10.845c0-5.988,4.853-10.843,10.841-10.843c5.987,0,10.84,4.855,10.84,10.843Z",
    fill: "#467e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.319,150.784c0,5.988-4.853,10.844-10.84,10.844-5.988,0-10.841-4.856-10.841-10.844c0-5.989,4.853-10.845,10.841-10.845c5.987,0,10.84,4.856,10.84,10.845Z",
    fill: "#467e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.238,142c0,5.988-4.854,10.844-10.841,10.844s-10.841-4.856-10.841-10.844c0-5.989,4.854-10.845,10.841-10.845s10.841,4.856,10.841,10.845Z",
    fill: "#467e2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,193.46h64.666v-72.262h-64.666v72.262Z",
    fill: "#b9622c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.953,193.46h51.526v-65.39h-51.526v65.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.953,193.46h-6.448v-72.262h64.667v12.515h-6.693v-5.643h-51.526v65.39Z",
    fill: "#965026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.911,193.46h-16.958v-65.39h51.527v5.643h-1.777v-3.742h-22.826v3.742h-2.322v-3.742h-22.825v61.637h.442h3.47h5.885h5.384v1.852Z",
    fill: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4673,193.46h98.4067v-169.5281h-98.4067v169.5281Z",
    fill: "#f6f0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4673,121.198h98.4067v-14.553h-98.4067v14.553Z",
    fill: "#cc7844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4673,28.1594h98.4067v-4.2282h-98.4067v4.2282Z",
    fill: "#c9c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.989,102.099h-86.1374v-63.6023h86.1374v63.6023Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8516,188.207h86.1374v-63.602h-86.1374v63.602Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.874,129.971h-4.886v-5.366h-86.1369v5.366h-7.3838v-8.773h98.4067v8.773Z",
    fill: "#c9c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.989,129.971h-2.01v-3.248h-82.1174v3.248h-2.01v-5.366h86.1374v5.366Z",
    fill: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.172,193.46h135.225v-80.123h-135.225v80.123Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.268,125.641h-83.096v-4.443h78.653v-7.861h2.222h54.35v4.228h-52.129v8.076Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,193.46h89.814v-65.589h-89.814v65.589Z",
    fill: "#f6f0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,136.603h89.814v-.823h-89.814v.823Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,146.393h89.814v-.823h-89.814v.823Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,156.184h89.814v-.825h-89.814v.825Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,165.972h89.814v-.823h-89.814v.823Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,175.763h89.814v-.824h-89.814v.824Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,185.552h89.814v-.822h-89.814v.822Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,193.46h2.023v-7.908h-2.023v7.908Z",
    fill: "#c9c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.666,184.73h-2.023v-8.967h2.023v8.967Zm0-9.791h-2.023v-8.966h2.023v8.966Zm0-9.79h-2.023v-8.965h2.023v8.965Zm0-9.79h-2.023v-8.966h2.023v8.966Zm0-9.789h-2.023v-8.967h2.023v8.967Zm0-9.791h-2.023v-7.908h89.814v1.921h-87.791v5.987Z",
    fill: "#c9c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,136.603h2.023v-.823h-2.023v.823Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,146.393h2.023v-.823h-2.023v.823Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,156.184h2.023v-.825h-2.023v.825Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,165.972h2.023v-.823h-2.023v.823Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,175.763h2.023v-.824h-2.023v.824Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.643,185.552h2.023v-.822h-2.023v.822Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.825,113.337h63.961v-7.376h-63.961v7.376Z",
    fill: "#b9622c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.825,113.337h2.222v-7.376h-2.222v7.376Z",
    fill: "#a4491e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3403,23.9316h337.3997v-7.3763h-337.3997v7.3763Z",
    fill: "#b9622c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,23.9316h5.429v-7.3763h-5.429v7.3763Z",
    fill: "#a4491e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,121.198h143.32v-14.553h-143.32v14.553Z",
    fill: "#cc7844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,121.198h12.253v-14.553h-12.253v14.553Z",
    fill: "#a7633a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,33.0004h143.32v-9.0691h-143.32v9.0691Z",
    fill: "#f6f0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.693,121.198h18.132v-88.1975h-18.132v88.1975Z",
    fill: "#f6f0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.758,33.0004h-12.253v-9.0686h143.32v4.2276h-131.067v4.841Z",
    fill: "#c9c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,106.645h125.188v-73.6443h-125.188v73.6443Z",
    fill: "#b9622c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.935,106.645h112.918v-67.5022h-112.918v67.5022Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.934,79.3937h-5.429v-46.3931h125.188v12.5148h-6.841v-6.3727h-112.918v40.251Z",
    fill: "#965026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.564,79.3937h-1.629v-40.251h112.917v6.3727h-1.629v-4.9454h-53.843v4.9454h-1.973v-4.9454h-53.843v38.8237Z",
    fill: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.853,106.645h6.841v-25.3505h-6.841v25.3505Z",
    fill: "#b8ac8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.852,106.645h-31.667v-1.426h30.039v-12.3557-11.5691h1.628v25.3508Z",
    fill: "#e3f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.911,106.645h5.232v-1.425h-5.232v1.425Z",
    fill: "#e3f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.758,106.645h11.153v-1.425h-11.153v1.425Z",
    fill: "#cbe7e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.1,106.645h-55.872v-1.426h31.179v-12.3557-11.5691h1.973v23.9248h22.72v1.426Z",
    fill: "#e3f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.227,106.645h-1.085v-25.3508h1.085v25.3508Z",
    fill: "#63595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.185,106.645h-1.085v-25.3508h1.085v25.3508Z",
    fill: "#63595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,81.2944h125.188v-1.901h-125.188v1.901Z",
    fill: "#63595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.505,106.645h5.429v-25.3505h-5.429v25.3505Z",
    fill: "#888573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.758,106.645h-6.823v-25.3508h1.629v23.9248h5.194v1.426Z",
    fill: "#a5bcbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.758,81.2944h-12.253v-1.9008h12.253v1.9008Z",
    fill: "#52494a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.401,7.37695h-72.421v-7.376722h72.421v7.376722Z",
    fill: "#b9622c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.875,193.46h58.631v-186.08334h-58.631v186.08334Z",
    fill: "#eeb462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.875,11.6041h58.631v-4.22713h-58.631v4.22713Z",
    fill: "#c29653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.262,38.4971h-11.646v-4.4339h11.646v4.4339Z",
    fill: "#d68c42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.252,81.0492h-11.647v-4.4339h11.647v4.4339Z",
    fill: "#d68c42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.909,162.159h-11.647v-4.436h11.647v4.436Z",
    fill: "#d68c42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.618,93.5597h-11.645v-4.4353h11.645v4.4353Z",
    fill: "#d68c42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.827,168.249c0,6.031-4.887,10.919-10.916,10.919s-10.915-4.888-10.915-10.919s4.886-10.92,10.915-10.92s10.916,4.889,10.916,10.92Z",
    fill: "#5fae32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.267,159.942c0,3.833-3.106,6.94-6.939,6.94-3.831,0-6.937-3.107-6.937-6.94s3.106-6.941,6.937-6.941c3.833,0,6.939,3.108,6.939,6.941Z",
    fill: "#5fae32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.148,171.251c0,5.387-4.365,9.755-9.751,9.755-5.384,0-9.751-4.368-9.751-9.755s4.367-9.754,9.751-9.754c5.386,0,9.751,4.367,9.751,9.754Z",
    fill: "#5fae32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.597,183.493c0,6.024-4.881,10.908-10.905,10.908-6.023,0-10.906-4.884-10.906-10.908c0-6.026,4.883-10.91,10.906-10.91c6.024,0,10.905,4.884,10.905,10.91Z",
    fill: "#5fae32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.503,184.73c0,7.278-5.899,13.178-13.175,13.178-7.275,0-13.174-5.9-13.174-13.178c0-7.279,5.899-13.18,13.174-13.18c7.276,0,13.175,5.901,13.175,13.18Z",
    fill: "#5fae32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.309,185.552c0,5.571-4.515,10.086-10.084,10.086-5.568,0-10.083-4.515-10.083-10.086c0-5.57,4.515-10.086,10.083-10.086c5.569,0,10.084,4.516,10.084,10.086Z",
    fill: "#5fae32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.536,184.657c0-.001,0-.004.002-.006-.002.002-.002.003-.002.006Zm.004-.031c0-.002,0-.003,0-.006c0,.002,0,.004,0,.006Zm.009-.093c0-.001.001-.004.001-.005c0,.001-.001.003-.001.005Zm.01-.114c0-.004,0-.006,0-.01c0,.002,0,.006,0,.01Zm.006-.062c0-.004,0-.009,0-.014c0,.005,0,.009,0,.014Zm.001-.033c.002-.005.002-.009.002-.013c0,.005,0,.008-.002.013Zm.018-.275c0-.005.001-.011.001-.015c0,.005-.001.01-.001.015Zm.009-.244c0-.007,0-.012.002-.019-.002.005-.002.013-.002.019Zm.002-.034c0-.022.001-.042.001-.065c0,.021-.001.045-.001.065Zm.002-.179c0-.007,0-.014,0-.019c0,.005,0,.013,0,.019Z",
    fill: "#3c672a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.541,153.004c-.005,0-.009-.001-.015-.001.006,0,.011.001.015.001Z",
    fill: "#3c672a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.15,174.046c-.686-.398-1.421-.723-2.192-.965.396-1.125.613-2.334.613-3.594c0-5.523-4.1-10.089-9.421-10.817-.072-.393-.177-.772-.313-1.139.662-.127,1.343-.199,2.04-.202.011,0,.023,0,.034,0c6.029,0,10.915,4.89,10.915,10.921c0,.015,0,.029,0,.044c0,.004,0,.007,0,.011c0,.015,0,.029,0,.044v.001c-.019,2.093-.636,4.042-1.676,5.696Z",
    fill: "#4e8f32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.558,158.774c-.981-2.642-3.502-4.534-6.485-4.534-.268,0-.522.048-.782.078c1.11-.8,2.458-1.291,3.926-1.316.003,0,.007,0,.01,0c.008,0,.016,0,.024,0c.007,0,.013,0,.02,0c.007-.001.013-.001.018-.001.014,0,.027,0,.039,0c.014,0,.027,0,.041,0c.005,0,.009,0,.014,0c.009.001.018.001.027.001.005,0,.01,0,.016,0c.008,0,.016,0,.024,0c.006,0,.013,0,.018,0c.011.002.023.002.035.002.008,0,.015,0,.023,0c.006,0,.01.001.015.001.01,0,.018,0,.027,0c.003,0,.006,0,.01.001c2.873.102,5.283,1.962,6.235,4.531.008-.003.016-.005.024-.006.136.366.242.746.314,1.138-.489-.067-.989-.101-1.496-.101-.718,0-1.418.073-2.097.206Z",
    fill: "#4e8f32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.862,194.184c3.272-1.884,5.48-5.407,5.48-9.454c0-4.035-2.197-7.551-5.454-9.438.434-.689.796-1.43,1.07-2.211.771.241,1.506.567,2.192.964-.001.004-.004.007-.005.01c3.167,1.834,5.331,5.21,5.448,9.108.001.029.001.061.003.092c0,.001,0,.003,0,.004c0,.014,0,.026,0,.039c0,.003,0,.006,0,.008.001.029.001.059.001.087c0,.004,0,.008,0,.012c0,.011,0,.021,0,.032c0,.004,0,.008,0,.013c0,.014,0,.027,0,.042c0,.011,0,.022,0,.034c0,.003,0,.006,0,.008c0,.009,0,.017,0,.025c0,.004,0,.008,0,.013c0,.006,0,.013,0,.019s0,.01,0,.014c0,.007,0,.014,0,.02s0,.01,0,.015c0,.006,0,.012,0,.018-.001.005-.001.009-.001.015c0,.007,0,.013,0,.02c0,.004,0,.008,0,.012c0,.023-.002.044-.002.065c0,.006,0,.01,0,.015-.001.007-.001.013-.001.019s0,.01,0,.014c0,.007,0,.014-.001.02c0,.004,0,.01,0,.014c0,.007,0,.012,0,.019c0,.005-.002.011-.002.015c0,.005,0,.011,0,.016c0,.007,0,.012-.001.018c0,.005,0,.011,0,.016s0,.011-.001.016c0,.007,0,.014,0,.021c0,.005-.002.01-.002.016c0,.008,0,.018-.001.027c0,.005,0,.012,0,.018c0,.004-.002.009-.002.015c0,.005,0,.012-.001.019c0,.004,0,.008,0,.013c0,.006-.001.012-.001.018c0,.005,0,.009,0,.015-.002.005-.002.012-.002.017c0,.006-.001.01-.001.015c0,.006,0,.011-.001.018c0,.005,0,.009,0,.015-.002.005-.002.012-.002.017c0,.007-.001.013-.001.02c0,.004,0,.008-.001.012c0,.011-.002.021-.002.031c0,.007-.001.012-.001.018c0,.005-.001.01-.001.016c0,.005-.002.012-.002.017s0,.009-.001.014c0,.005,0,.012-.002.019c0,.004,0,.009,0,.014-.001.006-.001.012-.002.019c0,.004,0,.008,0,.012-.002.007-.002.013-.003.02c0,.004,0,.007,0,.011-.001.007-.001.014-.001.022-.002.002-.002.005-.002.008-.002.027-.005.053-.006.079c0,.001-.002.004-.002.005c0,.008-.001.016-.001.024-.001.003-.002.004-.002.007c0,.008-.001.015-.002.023c0,.003,0,.006,0,.008-.002.009-.002.017-.003.025c0,.003,0,.004,0,.005-.001.008-.003.018-.003.026-.001.001-.001.004-.001.005-.005.057-.012.116-.019.174-.001.001-.001.003-.001.006-.002.008-.003.017-.003.027-.585,4.659-4.106,8.402-8.651,9.321Z",
    fill: "#4e8f32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.08,200L0,200v-6.54h481.08v6.54Z",
    fill: "#7cbf2c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.753,183.493h8.377v-59.813h-8.377v59.813Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.877,191.609h22.826v-61.638h-22.826v61.638Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.874,180.883l22.036-50.912h-9.85l-12.186,28.157v22.755Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.874,144.307l6.176-14.336h-3.483l-2.693,6.253v8.083Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.729,191.609h22.826v-61.638h-22.826v61.638Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.555,161.497l-13.029,30.112h9.846l3.183-7.356v-22.756Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.555,139.611l-22.383,51.998h3.469l18.914-43.917v-8.081Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.526,191.609h-5.885l11.27-26.167v13.723l-5.385,12.444Zm-9.354,0h-.443v-61.638h22.826v3.742h-7.644v23.657l-14.739,34.239Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.978,99.9813h-82.1167v-59.3651h82.1167v59.3651Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.958,40.6162L112.557,99.9813h9.779l25.395-59.3651h-9.773Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.547,40.6162L103.156,99.9813h3.447L132,40.6162h-3.453Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8613,186.088h82.1177v-59.365h-82.1177v59.365Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.958,126.723l-25.401,59.365h9.778l25.396-59.365h-9.773Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.547,126.723l-25.391,59.365h3.447L132,126.723h-3.453Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.563,105.22h53.844v-64.6499h-53.844v64.6499Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.407,70.024L263.339,105.22h9.778l5.29-12.3563v-22.8397Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.407,48.0105L253.939,105.22h3.446l21.022-49.1299v-8.0796Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.38,105.22h53.843v-64.6499h-53.843v64.6499Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.224,48.0105L309.756,105.22h3.446l21.022-49.1299v-8.0796Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.38,45.5153h53.843v-4.9453h-53.843v4.9453Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.934,105.22h-9.778l10.243-23.9254h4.825v11.5691l-5.29,12.3563Z",
    fill: "#8fdadd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.202,105.22h-3.446l10.233-23.9254h3.451L313.202,105.22Z",
    fill: "#8fdadd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.911,105.22h5.232v-23.9254h-5.232v23.9254Z",
    fill: "#83d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.758,105.22h11.153v-23.9254h-11.153v23.9254Z",
    fill: "#79cfd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.407,105.22h-5.29l5.29-12.3563v12.3563Zm-15.068,0h-5.954l10.238-23.9254h5.959L263.339,105.22Zm-9.4,0h-6.711v-23.9254h16.944L253.939,105.22Z",
    fill: "#83d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.117,105.22h-9.778l10.243-23.9254h4.825v11.5691l-5.29,12.3563Z",
    fill: "#8fdadd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.385,105.22h-3.446l10.233-23.9254h3.451L257.385,105.22Z",
    fill: "#8fdadd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.38,105.22h22.719v-23.9254h-22.719v23.9254Z",
    fill: "#83d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.563,105.22h5.195v-23.9254h-5.195v23.9254Z",
    fill: "#60a7ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.753,100.419h8.377v-59.8143h-8.377v59.8143Z",
    fill: "#53c6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.753,76.8669l8.377-19.8656v-8.9194l-8.377,19.8752v8.9098Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.066,100.419h-3.313v-23.5517l3.313-7.853v31.4047Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.753,67.9573v-27.3523h8.377v2.8139h-5.064v16.6814l-3.313,7.857Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.753,159.942l8.377-19.867v-8.919l-8.377,19.875v8.911Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.066,183.493h-3.313v-23.551l3.313-7.854v31.405Zm-3.313-32.462v-27.351h8.377v2.812h-5.064v16.682l-3.313,7.857Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.911,191.609h-5.385l5.385-12.444v12.444Z",
    fill: "#4bbabc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.641,191.609h-3.469l14.739-34.239v8.072l-11.27,26.167Z",
    fill: "#4bbabc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.911,79.3937h-16.348v-38.8237h53.844v4.9454h-37.496v33.8783Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.224,70.024L319.156,105.22h9.778l5.29-12.3563v-22.8397Z",
    fill: "#69cdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.224,105.22h-5.29l5.29-12.3563v12.3563Zm-15.068,0h-5.954l10.237-23.9254h5.96L319.156,105.22Zm-9.401,0h-5.57v-23.9254h15.804L309.755,105.22Z",
    fill: "#83d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,133.713h-9.85l1.62-3.742h9.849l-1.619,3.742Z",
    fill: "#4bbabc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.438,133.713h-3.482l1.611-3.742h3.483l-1.612,3.742Z",
    fill: "#4bbabc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.703,133.713h-2.413l1.62-3.742h-9.85l-1.62,3.742h-6.003l1.613-3.742h-3.483l-1.611,3.742h-1.079v-3.742h22.826v3.742Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.978,129.971h-5.638l1.39-3.248h-9.772l-1.39,3.248h-5.958l1.39-3.248h-3.453l-1.389,3.248h-57.2967v-3.248h82.1167v3.248Z",
    fill: "#41a2ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.34,129.971h-9.772l1.39-3.248h9.772l-1.39,3.248Z",
    fill: "#4bbabc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.753,76.8669v-8.9098l3.313-7.857v8.9139l-3.313,7.8529Z",
    fill: "#4bbabc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.753,159.942v-8.911l3.313-7.857v8.914l-3.313,7.854Z",
    fill: "#4bbabc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.61,129.971h-3.452l1.389-3.248h3.453l-1.39,3.248Z",
    fill: "#4bbabc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "eXft3SuVDe6185",
    d: "M41.757008,118.922715h216.486",
    transform: "matrix(2.190677 0 0 1.000001-178.60156-61.138809)",
    opacity: 0,
    fill: "none",
    stroke: "#002a3c",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe6186",
    transform: "translate(.000001 0.000001)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("text", {
    dx: 0,
    dy: 0,
    fontFamily: "\"eXft3SuVDe61:::Inter\"",
    fontSize: 25,
    fontWeight: 700,
    transform: "translate(19.657208 275.714619)",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 700,
    strokeWidth: 0
  }, "\n\"Replace Windows\"\n")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 30.942445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eXft3SuVDe6190",
    transform: "matrix(.320174 0 0 0.320174 76.05904 107.455626)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 570,
    rx: 8,
    ry: 8,
    transform: "translate(0 0.603015)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 3,
    ry: 3,
    transform: "translate(26 241)",
    fill: "#c0c0c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 265)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 289)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 313)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 361)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 409)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 337)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 385)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(26 433)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,156.5h126",
    fill: "none",
    stroke: "#555",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,497h126",
    transform: "translate(0 1.065937)",
    fill: "none",
    stroke: "#555",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,177h33",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,517.5h33",
    transform: "translate(0 1.065937)",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,177h86",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,517.5h86",
    transform: "translate(0 1.065937)",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,197h23",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,537.5h23",
    transform: "translate(0 1.065937)",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,197h86",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,537.5h86",
    fill: "none",
    stroke: "#ababab",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    dx: 0,
    dy: 0,
    fontFamily: "\"eXft3SuVDe61:::Inter\"",
    fontSize: 41,
    fontWeight: 600,
    transform: "translate(22.702608 62.828988)",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 600,
    strokeWidth: 0
  }, "\nEstimate\n")))))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@font-face {font-family: 'eXft3SuVDe61:::Inter';font-style: normal;font-weight: 600;src: url(data:font/ttf;charset=utf-8;base64,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) format('truetype');}@font-face {font-family: 'eXft3SuVDe61:::Inter';font-style: normal;font-weight: 700;src: url(data:font/ttf;charset=utf-8;base64,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) format('truetype');}\n")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpMultipleAppsEstimate);
export default __webpack_public_path__ + "static/media/LP-MultipleApps-Estimate.45152082b36583d8195e962c6d4a13c6.svg";
export { ForwardRef as ReactComponent };